{
  "hero": {
    "title": "Kontakt"
  },
  "intro": {
    "text": "Für Video-, Design- oder Digitalprojekte steht das Formular oder die Kontaktdaten unten zur Verfügung."
  },
  "form": {
    "title": "Nachricht senden",
    "fields": {
      "fullName": {
        "label": "Vollständiger Name"
      },
      "email": {
        "label": "E-Mail"
      },
      "message": {
        "label": "Nachricht"
      }
    },
    "submit": "Nachricht senden",
    "sending": "Wird gesendet...",
    "success": "Die Nachricht wurde gesendet.",
    "error": "Die Nachricht konnte nicht gesendet werden. Bitte erneut versuchen."
  },
  "direct": {
    "title": "Direkter Kontakt per E-Mail oder WhatsApp",
    "email": {
      "label": "E-Mail: octavian@khromatik.com",
      "tooltip": "E-Mail kopieren"
    },
    "whatsapp": "WhatsApp"
  }
}
